/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { SocialMedia, SocialMediaComponent } from './components/social-media.components';
import MsDyn365 from '@msdyn365-commerce/core';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICSocialShareItemConfig, ICSocialShareItemProps, socialMedia } from './c-social-share-item.props.autogenerated';

export interface ISocialShareItemViewProps extends ICSocialShareItemProps<ICSocialShareItemConfig> {
    SocialShareItemElement: React.ReactNode | null;
    SocialShareItem: IModuleProps;
}

/**
 *
 * SocialShareItem component.
 * @extends {React.PureComponent<ICSocialShareItemProps<ICSocialShareItemConfig>>}
 */
class SocialShareItem extends React.PureComponent<ICSocialShareItemProps<ICSocialShareItemConfig>> {
    constructor(props: ICSocialShareItemProps<ICSocialShareItemConfig>) {
        super(props);

        this._getSocialShareItem = this._getSocialShareItem.bind(this);
    }

    public render(): JSX.Element | null {
        const viewprops = {
            ...this.props,
            SocialShareItem: {
                moduleProps: this.props,
                className: 'ms-social-share-item'
            },
            SocialShareItemElement: this._getSocialShareItem()
        };

        return this.props.renderView(viewprops) as React.ReactElement;
    }

    private _getSocialShareItem(): React.ReactNode | null {
        const src = this.props.config.icon;
        if (MsDyn365.isBrowser) {
            switch (this.props.config.socialMedia) {
                case socialMedia.facebook:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Facebook}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_facebook`}
                            typeName={this.props.typeName}
                            data={{}}
                            src={src}
                        />
                    );
                case socialMedia.twitter:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Twitter}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_twitter`}
                            typeName={this.props.typeName}
                            data={{}}
                            src={src}
                        />
                    );
                case socialMedia.pinterest:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Pinterest}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_pinterest`}
                            typeName={this.props.typeName}
                            data={{}}
                            src={src}
                        />
                    );
                case socialMedia.linkedin:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Linkedin}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_linkedin`}
                            typeName={this.props.typeName}
                            data={{}}
                            src={src}
                        />
                    );
                case socialMedia.mail:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Mail}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_mail`}
                            typeName={this.props.typeName}
                            data={{}}
                            src={src}
                        />
                    );
                case socialMedia.whatsapp:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Whatsapp}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_whatsapp`}
                            typeName={this.props.typeName}
                            data={{}}
                            src={src}
                        />
                    );
                case socialMedia.instagram:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Instagram}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_instagram`}
                            typeName={this.props.typeName}
                            data={{ username: this.props.config.pimkieSocialUrl }}
                            src={src}
                        />
                    );
                case socialMedia.tiktok:
                    return (
                        <SocialMediaComponent
                            socialMedia={SocialMedia.Tiktok}
                            postUrl={document.URL}
                            context={this.context}
                            id={`${this.props.id}_tiktok`}
                            typeName={this.props.typeName}
                            data={{ username: this.props.config.pimkieSocialUrl }}
                            src={src}
                        />
                    );
                default:
                    return null;
            }
        }
        return null;
    }
}

export default SocialShareItem;
